export default __webpack_public_path__ + "static/media/Studio_Section1_Radio@2x.fd52192b.jpg";